export function catalogEntry(food) {
  const amount = Number(food.grams);
  if (!food.name?.trim() || !Number.isFinite(amount) || amount <= 0) throw new Error('Indica nombre y cantidad válida.');
  const unitType = ['ud', 'ml'].includes(food.unitType) ? food.unitType : 'g';
  const values = Object.fromEntries(['cal', 'prot', 'carbs', 'fat'].map(key => {
    const n = Number(food[key]);
    if (!Number.isFinite(n) || n < 0) throw new Error('Los nutrientes deben ser números positivos o cero.');
    return [key, n / amount];
  }));
  const barcode = String(food.barcode || '').trim();
  return { id: barcode ? `barcode:${barcode}` : `${food.name.trim().toLowerCase()}:${unitType}`, name: food.name.trim(), barcode, unitType, perUnit: values, source: food.source || 'Estimación revisada' };
}
export function portion(entry, amount) {
  amount = Number(amount);
  if (!Number.isFinite(amount) || amount <= 0) throw new Error('La ración debe ser mayor que cero.');
  return { name: entry.name, barcode: entry.barcode, source: entry.source, unitType: entry.unitType, grams: amount, ...Object.fromEntries(Object.entries(entry.perUnit).map(([key, n]) => [key, Math.round(n * amount * 10) / 10])), baseCalPerUnit: entry.perUnit.cal, baseProtPerUnit: entry.perUnit.prot, baseCarbsPerUnit: entry.perUnit.carbs, baseFatPerUnit: entry.perUnit.fat };
}
export function mergeCatalog(catalog, foods) {
  const map = new Map(catalog.map(entry => [entry.id, entry]));
  for (const food of foods) { const entry = catalogEntry(food); map.set(entry.id, entry); }
  return [...map.values()];
}
